// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"921f2d75","833":"412471f2"}[chunkId] + ".chunk.js";
};